import { SET_IS_REASON_SENDING } from './actions';

export const initialState = {
	isReasonSending: false,
};

const refusalReasonModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_IS_REASON_SENDING:
			return {
				...state,
				isReasonSending: payload,
			};
		default:
			return state;
	}
};

export default refusalReasonModalReducer;
